module.exports = __webpack_public_path__ + "static/img/blekey1.a87ddae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/blekey/key2/blekey1.jpg
// module id = WlMU
// module chunks = 0